import { useState } from 'react';

export default function Header() {
  const [showNotifications, setShowNotifications] = useState(false);

  return (
    <header className="h-16 bg-white border-b border-gray-200/80 flex items-center justify-between px-8">
      <div className="flex items-center gap-4 flex-1">
        <div className="relative flex-1 max-w-md">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
          <input
            type="text"
            placeholder="検索..."
            className="w-full pl-10 pr-4 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
          />
        </div>
      </div>

      <div className="flex items-center gap-3">
        <div className="relative">
          <button
            onClick={() => setShowNotifications(!showNotifications)}
            className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer relative"
          >
            <i className="ri-notification-3-line text-xl text-gray-600"></i>
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full"></span>
          </button>
          
          {showNotifications && (
            <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
              <div className="p-4 border-b border-gray-200">
                <h3 className="font-semibold text-gray-900">通知</h3>
              </div>
              <div className="max-h-96 overflow-y-auto">
                <div className="p-4 hover:bg-gray-50 border-b border-gray-100 cursor-pointer">
                  <p className="text-sm text-gray-900 font-medium">新しい3Dモデルがアップロードされました</p>
                  <p className="text-xs text-gray-500 mt-1">5分前</p>
                </div>
                <div className="p-4 hover:bg-gray-50 border-b border-gray-100 cursor-pointer">
                  <p className="text-sm text-gray-900 font-medium">施工データが更新されました</p>
                  <p className="text-xs text-gray-500 mt-1">1時間前</p>
                </div>
                <div className="p-4 hover:bg-gray-50 cursor-pointer">
                  <p className="text-sm text-gray-900 font-medium">店舗情報が追加されました</p>
                  <p className="text-xs text-gray-500 mt-1">3時間前</p>
                </div>
              </div>
            </div>
          )}
        </div>

        <button className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
          <i className="ri-settings-3-line text-xl text-gray-600"></i>
        </button>
      </div>
    </header>
  );
}
